// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerCommonDataUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Izenda Utils for commonDataStore
 */
import uiState from 'logic/Izenda.UiState';

import commonDataStore from './Izenda.ReportDesignerCommonDataStore';
import { flow, find, defaults } from 'lodash/fp';

export default {
  /**
   * get Function data from API
   * @method getFunctionData
   * @param  {int}        functionMode    Function Mode
   * @param  {string}        dataType     Izenda Data Type
   * @param  {string}        functionName Function name
   * @return {promise}                    Promise result filter object
   */
  getFunctionData: function(functionMode: number, dataType: string, functionName: string): any {
    return commonDataStore.loadReportFunction(functionMode, dataType, uiState.tenantId).then(
      flow(
        find({ name: functionName }),
        defaults({})
      )
    );
  },
  /**
   * get format data from api
   * @method getFormatData
   * @param  {string}        dataType     Izenda Data Type
   * @param  {string}        functionName Function name
   * @return {promise}                    Promise result filter object
   */
  getFormatData: function(dataType: string, formatName: string): any {
    return commonDataStore.loadReportFieldDataFormat(dataType).then(
      flow(
        find({ format: formatName }),
        defaults({})
      )
    );
  },

  /**
   * get format data from api
   * @method getFormatData
   * @param  {string}        dataType     Izenda Data Type
   * @param  {string}        functionName Function name
   * @return {promise}                    Promise result filter object
   */
  getFunction: function(functionMode: string, dataType: string): any {
    return commonDataStore.loadReportFunction(functionMode, dataType, uiState.tenantId);
  }
};



// WEBPACK FOOTER //
// ./ui/logic/Izenda.ReportDesignerCommonDataUtils.js